export default __webpack_public_path__ + "static/media/step-2-fr.c982238b.svg";